//
//
//
//

import Toggleable from "../../mixins/Toggleable";
import SpoferanUi from "../../main";
const PopupAlert = () => ({
    component: import('./PopupAlert')
});

export default {
    name: "GlobalPopupAlert",
    components: {PopupAlert},

    mixins: [Toggleable],

    data() {
        return {
            props: {},
            listeners: {}
        }
    },

    beforeMount() {
        SpoferanUi.eventBus.$on('alert_toggle', this.handleToggle);
    },

    beforeDestroy() {
        SpoferanUi.eventBus.$off('alert_toggle', this.handleToggle);
    },

    methods: {
        handleToggle(state, props, listeners) {
            this.isActive = state;
            this.props = props;
            this.listeners = listeners;
        }
    }
}
